import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { TmAccount } from '@/tscapi/model/account';
import { TmCart } from '@/tscapi/model/cart';
import { TmAccountRequest } from '@/tscapi/model/request/account-request';
import { TmMergeCartRequest } from '@/tscapi/model/request/account_cart-request';
import { createAccount, setUserToken, signIn } from '@/tscapi/service/account.service';
import { mergeCart, getAccountCart } from '@/tscapi/service/accountcart.service';
import http from '@/tscapi/service/httpservice';
import { Storage } from '@/tscapi/utils/browser-storage';
import { Cookie } from '@/tscapi/utils/cookie';

interface PayloadType {
    customernumber?: string;
    phone?: string;
    email?: string;
    subscribe?: boolean | 'indeterminate';
    newPassword?: string;
    retypeNewPassword?: string;
    IsPhoneCustomer?: boolean;
    IsGuest?: boolean;
}

// used to create/add a TSC credit card
// used in remove card modal on
export const useCreatePhoneAccount = () => {
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    const queryClient = useQueryClient();
    return {
        ...useMutation({
            mutationFn: async (payload: PayloadType) => {
                return http.post(`${base}${lang}/accounts/`, payload);
            },
            onSuccess: async (response, variables, context) => {
                setUserToken(response.data as TmAccount);
                //remove access token from cached user storage
                const cleanedResponse: TmAccount = { ...response.data, AccessToken: null };
                //cart merge
                let accountCartData: TmCart;
                if (cookie.CartGuid) {
                    const cartReq: TmMergeCartRequest = new TmMergeCartRequest();
                    cartReq.CartGuid = cookie.CartGuid;
                    const accountCart = await mergeCart(cartReq);
                    if (accountCart && accountCart.data) {
                        accountCartData = accountCart.data;
                    }
                } else {
                    const accountCart = await getAccountCart();
                    if (accountCart && accountCart.data) {
                        accountCartData = accountCart.data;
                    }
                }
                cookie.UserName = accountCartData.Buyer.BillingAddress.FirstName;
                cookie.LastName = accountCartData.Buyer.BillingAddress.LastName;
                cookie.CartGuid = accountCartData.CartGuid;
                cookie.CartMerge = accountCartData.IsCartMerged.toString();
                cookie.CartProductCount = accountCartData.OrderSummary.TotalQuantity.toString();
                queryClient.setQueryData(
                    ['account', cookie.UserAccessToken?.Edp, cookie.Language],
                    cleanedResponse as TmAccount,
                );
            },
            onError: (error, variables, context) => {
                console.log('error');
            },
        }),
    };
};
